import React, {Component} from 'react';
import { Actions } from '../../actions';
import { connect } from 'react-redux';
import {Redirect} from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Register from "../../components/Auth/register";
import _ from 'underscore';
import { _queryParamsMixin } from '../../utils';

_queryParamsMixin();

class RegisterContainer extends Component {
    state = {
        valueUrl: null,
        token: null,
        filledEmail: null,
    };

    componentDidMount() {
        this._parseUrl();
    }

    _parseUrl = () => {
        let url = this.props.location.pathname || "";

        const queryParams = _.getQueryParams(url);
        const tokenKey = Object.keys(queryParams).find(k => k.startsWith('register/'))
        const token = tokenKey ? tokenKey.replace('register/','') : null;
        
        if (token) {
            if (queryParams.email) {
                this.setState({
                    token: token,
                    filledEmail: queryParams.email,
                    validUrl: true,
                });
            } else {
                this.setState({
                    token: token,
                    validUrl: true,
                });
            }
        } else {
            this.setState({
                validUrl: false
            })
        }
    }

    _handleOnSubmit (values) {

        const { filledEmail } = this.state;

        this.props.doRegistration({
            username: values.username,
            password: values.password,
            password_confirm: values.confirmPassword,
            email: filledEmail ? filledEmail : values.email,
            token: this.state.token,
        });
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: '/' } };
        const { t } = this.props;

        if (this.props.isAuthenticated) {
            return <Redirect to={from} />
        }

        if (this.props.isRegistrationDone) {
                return <Redirect to={{
                    pathname: "/login",
                    state: { message: t("AUTH.LOGIN.REGISTER_SUCCESS") }
             }} />
        }

        return <Register 
            validUrl={this.state.validUrl}
            filledEmail={this.state.filledEmail}
            onSubmit={this._handleOnSubmit.bind(this)}/>;
    }
}

const mapStateToProps = state => {
    return {
        ...state.auth
    }
};

export default connect(mapStateToProps, Actions)(withTranslation()(RegisterContainer));
